import DailyMenuOffer from "@/model/dailymenu/DailyMenuOffer";

export default class MenuOffer {
  private constructor (
    readonly menuList: DailyMenuOffer[],

  ) {}

  static createEmpty (): MenuOffer {
    return new MenuOffer([])
  }

  static createFromResponse (responseData: any): MenuOffer {
    return new MenuOffer(
        responseData.map( (item:any):DailyMenuOffer => DailyMenuOffer.createFromResponse(item))
    )

  }
}
